import { InformationCircleIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import React from 'react'

const TRANSITION_PREVIEWS = {
  'On Outstanding List': [
    'This will create an Outstanding List entry for this RO.',
    'You can then manage line items and track progress from the OL detail page.',
  ],
}

const TransitionPreview = ({ targetStatus }) => {
  const messages = TRANSITION_PREVIEWS[targetStatus]
  if (!messages) return null

  return (
    <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
      <div className="flex items-start gap-2">
        <InformationCircleIcon className="h-5 w-5 shrink-0 text-amber-600" />
        <div className="space-y-1">
          {messages.map((msg, i) => (
            // Static list — safe to key by index
            // eslint-disable-next-line react/no-array-index-key
            <p key={`msg-${i}`} className="text-sm text-amber-800">
              {msg}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}

TransitionPreview.propTypes = {
  targetStatus: PropTypes.string.isRequired,
}

export default TransitionPreview
